import { render, staticRenderFns } from "./vy1.vue?vue&type=template&id=f1210b1e&scoped=true"
import script from "./vy1.vue?vue&type=script&lang=js"
export * from "./vy1.vue?vue&type=script&lang=js"
import style0 from "./vy1.vue?vue&type=style&index=0&id=f1210b1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1210b1e",
  null
  
)

export default component.exports